module.exports = __webpack_public_path__ + "img/Unidad19-3.5ec79fdb.png";